var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":"lg"}},[_c('div',{staticClass:"box sombra"},[_c('h3',[_vm._v("Mi Tienda")]),_c('StoreForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }